<template>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.4636 4.16985C10.8541 4.56038 10.8541 5.19355 10.4636 5.58407L5.04705 11.0005L21.3663 11.0005C21.9186 11.0005 22.3663 11.4482 22.3663 12.0005C22.3663 12.5528 21.9186 13.0005 21.3663 13.0005L5.04705 13.0005L10.4618 18.4152C10.8523 18.8057 10.8523 19.4389 10.4618 19.8294C10.0712 20.2199 9.43807 20.2199 9.04755 19.8294L1.92571 12.7076C1.73817 12.52 1.63281 12.2657 1.63281 12.0005C1.63281 11.7352 1.73817 11.4809 1.92571 11.2934L9.0494 4.16984C9.43993 3.77932 10.0731 3.77933 10.4636 4.16985Z"
			fill="#1D1E20"
		/>
	</svg>
</template>
